import { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { Bell } from 'lucide-react'
import { useEscape } from '@core/shortcuts'
import ListaNotificacoes from './ListaNotificacoes'
import { textoDoContador } from './notificacoesRegras'
import { useContagemDeNotificacoes } from './useContagem'

/**
 * O sino na barra de topo: quantas há por ler e, ao abrir, a lista das
 * últimas (abrir uma no sítio marca-a como lida). A página das
 * notificações (lista e preferências do email) fica a um clique.
 */
export default function SinoNotificacoes({ workspaceSlug }: { workspaceSlug: string }) {
  const { porLer, definir } = useContagemDeNotificacoes(true)
  const [aberto, setAberto] = useState(false)
  const wrapRef = useRef<HTMLDivElement | null>(null)

  useEscape(aberto, () => setAberto(false))
  useEffect(() => {
    if (!aberto) return
    const fora = (e: PointerEvent) => {
      const node = wrapRef.current
      if (node && !node.contains(e.target as Node)) setAberto(false)
    }
    window.addEventListener('pointerdown', fora, { capture: true })
    return () => window.removeEventListener('pointerdown', fora, { capture: true })
  }, [aberto])

  const contador = textoDoContador(porLer)
  const titulo = porLer > 0 ? `Notificações: ${porLer} por ler` : 'Notificações'

  return (
    <div ref={wrapRef} className="relative shrink-0">
      <button
        type="button"
        onClick={() => setAberto((v) => !v)}
        title={titulo}
        aria-label={titulo}
        aria-haspopup="dialog"
        aria-expanded={aberto}
        className="relative flex items-center rounded px-1.5 py-0.5 text-[var(--color-text-muted)] hover:bg-[var(--color-bg)] hover:text-[var(--color-text)]"
      >
        <Bell size={14} aria-hidden />
        {contador && (
          <span
            aria-hidden
            className="absolute -right-1 -top-1 min-w-[14px] rounded-full bg-[var(--color-accent)] px-1 text-center text-[9px] font-semibold leading-[14px] text-[var(--color-bg)]"
          >
            {contador}
          </span>
        )}
      </button>
      {aberto && (
        <div
          role="dialog"
          aria-label="Notificações"
          className="absolute right-0 top-full z-[900] mt-1 flex max-h-[70vh] w-[380px] flex-col rounded border border-[var(--color-border)] bg-[var(--color-panel-elevated)] shadow-xl"
        >
          <ListaNotificacoes
            className="flex-1"
            aoMudarContagem={definir}
            aoAbrir={() => setAberto(false)}
          />
          <div className="border-t border-[var(--color-border)] px-3 py-2 text-xs">
            <Link
              to={`/${workspaceSlug}/notificacoes`}
              onClick={() => setAberto(false)}
              className="text-[var(--color-accent)] hover:underline"
            >
              Ver todas e preferências do email
            </Link>
          </div>
        </div>
      )}
    </div>
  )
}
